import { render, staticRenderFns } from "./BackgroundHeader.vue?vue&type=template&id=c2e88c50&scoped=true&"
import script from "./BackgroundHeader.vue?vue&type=script&lang=js&"
export * from "./BackgroundHeader.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundHeader.vue?vue&type=style&index=0&id=c2e88c50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e88c50",
  null
  
)

export default component.exports